import React from 'react'

import { Drawer } from 'antd'
import QuotaCard from './QuotaCard'
import QuotaFormModalProvider from '../../../../Providers/Forms/QuotaForm/QuotaFormModalProvider'
import QuotaFormButton from '../../../../Providers/Forms/QuotaForm/QuotaFormButton'
import moment from 'moment'

import '../../../../assets/quotas.scss'

const DEFAULT_SEED = { total: 0, startDate: moment(), endDate: moment() }

const SchoolQuotasDrawer = ({ mode, quotas, seed = {}, studentPathways, title, visible, onChange, onClose }) => {
  return (
    <Drawer
      className='school-quotas-drawer'
      width='40%'
      onClose={onClose}
      visible={visible}
      title={title}
    >
      <div style={{ maxHeight: 'calc(100% - 95px)', overflowY: 'auto' }}>
        {quotas.map((q, index) => (
          <QuotaCard
            key={`card-${q.id}`}
            mode={mode}
            quota={q}
            studentPathways={studentPathways}
            onChange={onChange}
          />
        ))}
      </div>
      {seed && (
        <div className='pd-8 flex-row jc-ctr'>
          <QuotaFormModalProvider mode={mode} studentPathways={studentPathways}>
            <QuotaFormButton seed={{ ...DEFAULT_SEED, ...seed }} callback={onChange} />
          </QuotaFormModalProvider>
        </div>
      )}
    </Drawer>
  )
}
export default SchoolQuotasDrawer
